export default __webpack_public_path__ + "static/CustomerPic1-3c0f5171051db388b2e754a0c65889c7.png";